<script setup>
import { computed } from 'vue'
import { Head } from '@inertiajs/vue3'
import PublicLayout from '@/Layouts/PublicLayout.vue'
import { journalBySlug } from '@/data/content.js'

defineOptions({ layout: PublicLayout })

const props = defineProps({ slug: { type: String, default: '' } })
const post = computed(() => journalBySlug(props.slug))
</script>

<template>
  <Head>
    <title>{{ post ? `${post.title} · Kenya2Go` : 'Journal · Kenya2Go' }}</title>
    <meta v-if="post" name="description" :content="post.dek">
  </Head>

  <div v-if="post" class="kp">
    <article class="jarticle">
      <a href="/journal" class="jarticle__back">← Journal</a>
      <p class="jarticle__cat">{{ post.category }}</p>
      <h1 class="jarticle__title">{{ post.title }}</h1>
      <p class="jarticle__dek">{{ post.dek }}</p>
      <p class="jarticle__meta">{{ post.date }} · {{ post.readMins }} min read</p>

      <div class="jarticle__art" :style="{ '--h': post.hue }"></div>

      <div class="kp-prose jarticle__body">
        <p v-for="(para, i) in post.body" :key="i">{{ para }}</p>
      </div>

      <div class="jarticle__foot">
        <p>Want to experience this for yourself?</p>
        <a href="/tours" class="kp-btn kp-btn--solid">Browse experiences</a>
      </div>
    </article>
  </div>

  <div v-else class="kp">
    <section class="kp-section kp-section--narrow" style="text-align:center">
      <h1 class="kp-title">Story not found</h1>
      <p class="kp-prose">That one isn’t live yet. <a href="/journal" style="color:var(--accent);text-decoration:none">Back to the Journal →</a></p>
    </section>
  </div>
</template>

<style scoped>
.jarticle { max-width: 44rem; margin: 0 auto; padding: 3.5rem 1.5rem 4rem; }
.jarticle__back { color: var(--muted); text-decoration: none; font-size: 0.85rem; font-weight: 500; }
.jarticle__cat { margin: 1.6rem 0 0.6rem; font-size: 0.72rem; letter-spacing: 0.16em; text-transform: uppercase; font-weight: 600; color: var(--accent); }
.jarticle__title { font-family: var(--display); font-weight: 400; font-size: clamp(2.2rem, 5vw, 3.2rem); line-height: 1.04; letter-spacing: -0.02em; margin: 0 0 0.8rem; color: var(--ink); }
.jarticle__dek { font-family: var(--display); font-style: italic; font-size: 1.25rem; line-height: 1.4; color: var(--inkSoft); margin: 0 0 1rem; }
.jarticle__meta { font-size: 0.85rem; color: var(--muted); margin: 0 0 2rem; }
.jarticle__art { aspect-ratio: 16 / 8; border-radius: var(--radius-lg); margin-bottom: 2.5rem; position: relative; overflow: hidden;
  background: linear-gradient(150deg, oklch(0.68 0.15 calc(var(--h))) 0%, oklch(0.42 0.11 calc(var(--h) + 16)) 100%); }
.jarticle__art::after { content: ''; position: absolute; inset: 0; background: radial-gradient(80% 80% at 25% 20%, oklch(1 0 0 / 0.12), transparent 60%); }
.jarticle__foot { margin-top: 3rem; padding-top: 2rem; border-top: 1px solid var(--line); text-align: center; }
.jarticle__foot p { color: var(--inkSoft); margin: 0 0 1rem; }
</style>
